export default "__VITE_ASSET__121beb74__"